/* Lunai quick-add (R-QA) — media frame crossfade.
   The frame markup is static inside quick-add-modal (outside the
   re-rendered content-info). On colour/variant selection the SELECTED
   VARIANT's image fades in over the previous one (<= 200ms; instant
   under prefers-reduced-motion); products or variants without an image
   fall back to the product's featured image, which the frame starts on. */
(function () {
  if (window.lunaiQuickAddMedia) return;
  window.lunaiQuickAddMedia = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function frameFor(sectionId) {
    /* variantChange fires from the product-info INSIDE an open modal.
       Dawn rewrites the modal copy's ids to quickadd-<id> and publishes
       the ORIGINAL id (data-original-section), so match either. */
    var info =
      document.querySelector('.quick-add-modal [data-original-section="' + sectionId + '"]') ||
      document.querySelector('.quick-add-modal [data-section="' + sectionId + '"]');
    var modal = info && info.closest('quick-add-modal');
    return modal && modal.querySelector('[data-qa-media]');
  }

  function swapTo(frame, src) {
    if (!src) src = frame.getAttribute('data-qa-featured') || '';
    if (!src) return;
    var imgs = frame.querySelectorAll('[data-qa-img]');
    if (!imgs.length) return; /* no-photo product: pastel + luna stays */
    var front = frame.querySelector('[data-qa-img].is-front') || imgs[0];
    if ((front.currentSrc || front.src) === src || front.getAttribute('src') === src) return;
    var back = imgs.length > 1 ? (imgs[0] === front ? imgs[1] : imgs[0]) : null;
    if (!back || reduce.matches) {
      front.src = src;
      return;
    }
    back.hidden = false;
    var done = function () {
      back.classList.add('is-front');
      front.classList.remove('is-front');
    };
    if (back.getAttribute('src') === src && back.complete) {
      done();
    } else {
      back.addEventListener('load', done, { once: true });
      back.src = src;
    }
  }

  function widthed(src) {
    if (!src) return null;
    if (src.indexOf('width=') === -1) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
    return src;
  }

  /* On open, sync the frame with the PRESELECTED variant (the frame's
     Liquid default is the product's featured image). */
  document.addEventListener('product-info:loaded', function (e) {
    var modal = e.target && e.target.closest && e.target.closest('quick-add-modal');
    if (!modal) return;
    var frame = modal.querySelector('[data-qa-media]');
    var script = modal.querySelector('[data-selected-variant]');
    if (!frame || !script) return;
    try {
      var v = JSON.parse(script.textContent);
      var src =
        (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) ||
        (v.featured_image && v.featured_image.src) || null;
      swapTo(frame, widthed(src));
    } catch (_) {}
  });

  /* ── Direct add (single-variant bag on cards) — migrated from the card
     snippet's inline script so it also runs where cards arrive via the
     Section Rendering API (wishlist). Consistent with R-QA: the drawer
     content + bubble update QUIETLY, the drawer does not open; the bag's
     own is-done check + live region announce the add. */
  function announce(msg) {
    var live = document.getElementById('lunai-live');
    if (!live) {
      live = document.createElement('span');
      live.id = 'lunai-live';
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 30);
  }

  function quietCartRefresh(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections && data.sections['cart-drawer']) {
      var target = document.querySelector('#CartDrawer');
      var src = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
      if (target && src) target.innerHTML = src.innerHTML;
      drawer.classList.remove('is-empty');
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    if (data.sections && data.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var fresh = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }
  }

  if (!window.lunaiQuickAdd) {
    window.lunaiQuickAdd = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pcard-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      var LS = window.lunaiStrings || {};
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: Number(btn.getAttribute('data-pcard-add')),
          quantity: 1,
          /* P-09: ask Shopify to render the drawer section only when a
             drawer exists. Under the cart-page model it doesn't, and
             rendering it would be a wasted section on every card add. */
          sections: document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      }).then(function (data) {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        announce(LS['cart.added_announcement'] || 'Dodano v košarico.');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
        quietCartRefresh(data);
      }).catch(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-error');
        announce(LS['cart.add_error'] || 'Dodajanje ni uspelo. Poskusite znova.');
        setTimeout(function () { btn.classList.remove('is-error'); }, 2200);
      });
    });
  }

  /* PUB_SUB_EVENTS is a top-level const (global binding, NOT a window
     property) — typeof is the only safe existence check. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data) return;
      var frame = frameFor(data.sectionId);
      if (!frame) return;
      var v = data.variant;
      var src =
        (v && v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) ||
        (v && v.featured_image && v.featured_image.src) ||
        null;
      swapTo(frame, widthed(src));
    });
  }
})();
